import React from 'react';

const input = [10, 8, 2, 1, 6, 3, 9, 4, 7, 5];

const quickSort = nums => {
    if (nums.length <= 1) {
        return nums;
    }

    // get the last number
    const pivot = nums[nums.length - 1];
    const left = []
    const right = []

    for (let i = 0; i < nums.length - 1; i++) {
        if (nums[i] < pivot) {
            left.push(nums[i]);
        }
        else { right.push(nums[i]) };
    }

    return [...quickSort(left), pivot, ...quickSort(right)];
}

const Sort = () => {
    return (<div>
        <p>{quickSort(input)}</p>
    </div>)
}

export default Sort;